export const educationData = [
    {
        id: 1,
        institution: 'Osmania Medical College- Hyderabad, India',
        course: 'M.B.B.S ( Bachelors in Medicine and Bachelors in Surgery)',
        startYear: '2003',
        endYear: '2009'
    },
    {
        id: 2,
        institution: 'Kamineni Institute of Medical Sciences',
        course: 'D.G.O  (Diploma in Gynecology and Obstetrics)',
        startYear: '2019',
        endYear: '2021'
    },
]